export enum HttpErrorResponseEnum {
  USER_INACTIVE = 'USER_INACTIVE',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_EXIST = 'USER_ALREADY_EXIST',
  USER_NOT_CONFIRMED = 'USER_NOT_CONFIRMED',
  USER_DEACTIVATED = 'USER_DEACTIVATED',
  MEMBER_UNAVAILABLE = 'MEMBER_UNAVAILABLE',
  CANNOT_PROCEED_PAYMENT = 'CANNOT_PROCEED_PAYMENT',
  STRIPE_RATE_LIMIT = 'STRIPE_RATE_LIMIT',
  STRIPE_INACTIVE_CUSTOMER = 'STRIPE_INACTIVE_CUSTOMER',
  SOCIAL_MEDIA_EMAIL_NOT_FOUND = 'SOCIAL_MEDIA_EMAIL_NOT_FOUND',
  LAB_TEST_CODE_EXISTS = 'LAB_TEST_CODE_EXISTS',
  PAYMENT_TYPE_CHANGE_NOT_ALLOWED = 'PAYMENT_TYPE_CHANGE_NOT_ALLOWED',
  INVOICE_BILLING_REQUIRED = 'INVOICE_BILLING_REQUIRED',
  MANUAL_PAYMENT_INVALID_PERIOD = 'MANUAL_PAYMENT_INVALID_PERIOD',
  MANUAL_PAYMENT_ALREADY_VOIDED = 'MANUAL_PAYMENT_ALREADY_VOIDED',
  ALREADY_INVOICE_BILLING = 'ALREADY_INVOICE_BILLING',
  INVOICE_BILLING_SWITCH_PARTNER = 'INVOICE_BILLING_SWITCH_PARTNER',
  INVOICE_BILLING_SWITCH_SHARED_ACCOUNT = 'INVOICE_BILLING_SWITCH_SHARED_ACCOUNT',
  SUBSCRIPTION_CHANGE_SAME_PROVIDER = 'SUBSCRIPTION_CHANGE_SAME_PROVIDER',
  SUBSCRIPTION_CHANGE_INVALID_SETTINGS = 'SUBSCRIPTION_CHANGE_INVALID_SETTINGS',
  PAYSTACK_FIXED_PRICE_TOO_LOW = 'PAYSTACK_FIXED_PRICE_TOO_LOW',
  // LHMS-5200
  ACCESS_GRANT_INVALID_DATE = 'ACCESS_GRANT_INVALID_DATE',
  ACCESS_EXTENSION_LIMIT_EXCEEDED = 'ACCESS_EXTENSION_LIMIT_EXCEEDED',
  ACCESS_EXTENSION_REQUIRES_PAYMENT = 'ACCESS_EXTENSION_REQUIRES_PAYMENT',
}
